import {css, cx} from "@panda/css";

import {CheckboxControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {mktOptinsCopy} from "../../lead/constants/mkt_optins_copy";

interface IProps {
    showForm: boolean;
    initialValues: {
        marketing_email: boolean;
        marketing_sms: boolean;
    };
    formId: string;
    className?: string;
}

export function UserMktOptins(props: IProps) {
    const {showForm, initialValues, formId, className} = props;

    if (initialValues.marketing_email && initialValues.marketing_sms) {
        return null;
    }

    return (
        <div className={cx(className, optins)}>
            <Text variant="info_txt_2" as="span">
                {mktOptinsCopy}
            </Text>
            {(showForm || (!showForm && !initialValues.marketing_email)) && (
                <CheckboxControlled
                    name="marketing_email"
                    id={`mkt_email_${formId}`}
                    labelContent={
                        <Text as="span" variant="info_txt_1" dataTestId={OFFER_TEST_IDS.LEAD_FORM.EMAIL_CONSENT_CHECKBOX}>
                            o adres email
                            <Text as="span" variant="info_txt_1" className={redStar}>
                                *
                            </Text>
                        </Text>
                    }
                    checkedMarkColor="#02D054"
                />
            )}
            {(showForm || (!showForm && !initialValues.marketing_sms)) && (
                <CheckboxControlled
                    name="marketing_sms"
                    id={`mkt_sms_${formId}`}
                    labelContent={
                        <Text as="span" variant="info_txt_1" dataTestId={OFFER_TEST_IDS.LEAD_FORM.PHONE_CONSENT_CHECKBOX}>
                            o numer telefonu
                        </Text>
                    }
                    checkedMarkColor="#02D054"
                />
            )}
        </div>
    );
}

const optins = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const redStar = css({
    color: "var(--colors-danger)"
});
import {css, cx} from "@panda/css";

import {CheckboxControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {mktOptinsCopy} from "../../lead/constants/mkt_optins_copy";

interface IProps {
    showForm: boolean;
    initialValues: {
        marketing_email: boolean;
        marketing_sms: boolean;
    };
    formId: string;
    className?: string;
}

export function UserMktOptins(props: IProps) {
    const {showForm, initialValues, formId, className} = props;

    if (initialValues.marketing_email && initialValues.marketing_sms) {
        return null;
    }

    return (
        <div className={cx(className, optins)}>
            <Text variant="info_txt_2" as="span">
                {mktOptinsCopy}
            </Text>
            {(showForm || (!showForm && !initialValues.marketing_email)) && (
                <CheckboxControlled
                    name="marketing_email"
                    id={`mkt_email_${formId}`}
                    labelContent={
                        <Text as="span" variant="info_txt_1" dataTestId={OFFER_TEST_IDS.LEAD_FORM.EMAIL_CONSENT_CHECKBOX}>
                            o adres email
                            <Text as="span" variant="info_txt_1" className={redStar}>
                                *
                            </Text>
                        </Text>
                    }
                    checkedMarkColor="#02D054"
                />
            )}
            {(showForm || (!showForm && !initialValues.marketing_sms)) && (
                <CheckboxControlled
                    name="marketing_sms"
                    id={`mkt_sms_${formId}`}
                    labelContent={
                        <Text as="span" variant="info_txt_1" dataTestId={OFFER_TEST_IDS.LEAD_FORM.PHONE_CONSENT_CHECKBOX}>
                            o numer telefonu
                        </Text>
                    }
                    checkedMarkColor="#02D054"
                />
            )}
        </div>
    );
}

const optins = css({
    display: "flex",
    flexDirection: "column",
    gap: 1
});

const redStar = css({
    color: "var(--colors-danger)"
});
